import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useNavigate } from "react-router-dom";

export const RequiredLoginModal = ({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (value: boolean) => void;
}) => {
  const navigate = useNavigate();

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="[&>button]:hidden py-8 w-[350px] md:w-[450px] h-[280px] ring-0 ring-transparent">
        <DialogHeader className=" flex flex-col justify-center">
          <DialogTitle className="text-xl text-center text-black font-bold">
            <p>エントリーを確定するためには</p>
            <p>登録・ログインが必要です</p>
          </DialogTitle>
        </DialogHeader>

        <div className="flex flex-col w-full items-center justify-center mt-5">
          <Button
            className="text-lg w-full py-[25px] text-white rounded-lg font-bold"
            variant="default"
            onClick={() => navigate("/login")}
          >
            ログインする
          </Button>
          <Button className="text-base mt-3" variant="link" onClick={() => setOpen(false)}>
            閉じる
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
